import { createFeatureSelector } from '@ngrx/store';
import { WATCH_LISTS_STATE_KEY } from './watch-lists-feature.key';
import { WatchListsFeatureState } from './watch-lists-feature.model';


export const selectWatchListsFeatureState = createFeatureSelector<WatchListsFeatureState>(WATCH_LISTS_STATE_KEY);
